<template>
  <div>
    <!-- 搜索筛选 -->
    <div class="query-select">
      <el-form :inline="true" :model="pageParams" class="user-search">
        <el-form-item label="课程名称">
          <el-input
            v-model.trim="pageParams.courseName"
            placeholder="请输入课程名称"
          ></el-input>
        </el-form-item>
        <el-form-item label="类型">
          <el-select v-model="pageParams.courseType" placeholder="请搜索类型">
            <el-option
              v-for="(item, index) in courseTypeOptions"
              :key="item.dictCode || `${item.dictValue}-${index}`"
              :label="item.dictLabel"
              :value="item.dictValue"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="发布人">
          <el-input
            v-model.trim="pageParams.publisher"
            placeholder="请输入发布人"
          ></el-input>
        </el-form-item>
      </el-form>
      <div class="div_select_button">
        <el-button
          plain
          round
          size="small"
          type="primary"
          icon="el-icon-search"
          @click="select"
          >查询</el-button
        >
        <el-button
          plain
          round
          size="small"
          type="warning"
          icon="el-icon-refresh-left"
          @click="resetSelect"
          >重置</el-button
        >
        <el-button
          plain
          round
          size="small"
          type="success"
          icon="el-icon-plus"
          @click="addForms"
          >新增</el-button
        >
      </div>
    </div>
    <!--列表-->
    <div class="main-table">
      <el-table
        header-cell-class-name="table-header"
        stripe
        size="small"
        :data="listData"
        highlight-current-row
        v-loading="loading"
        element-loading-text="拼命加载中"
        style="width: 85vw"
      >
        <el-table-column align="center" type="index" width="60">
        </el-table-column>

        <el-table-column
          align="center"
          prop="courseName"
          label="课程名称	"
          show-overflow-tooltip
        >
        </el-table-column>
        <el-table-column
          align="center"
          label="分类"
          min-width="140"
          show-overflow-tooltip
        >
          <template slot-scope="scope">
            <span v-if="scope.row.categoryOne || scope.row.categoryTwo">
              {{ scope.row.categoryOne || "-"
              }}<template v-if="scope.row.categoryTwo"
                >/{{ scope.row.categoryTwo }}</template
              >
            </span>
            <span v-else>-</span>
          </template>
        </el-table-column>
        <el-table-column
          align="center"
          prop="courseName"
          label="课程类型"
          width="120"
          show-overflow-tooltip
        >
          <template slot-scope="scope">
            <dict-tag :type="DICT_TYPE.COURSE_TYPE" :value="scope.row.courseType" />
          </template>
        </el-table-column>
        <el-table-column
          align="center"
          prop="lessonCount"
          label="课时	"
          width="100"
          show-overflow-tooltip
        >
        </el-table-column>

        <el-table-column
          align="center"
          prop="learnerCount"
          label="学习人数"
          width="100"
          show-overflow-tooltip
        >
        </el-table-column>
        <el-table-column
          align="center"
          prop="publisher"
          label="发布人"
          width="100"
          show-overflow-tooltip
        >
        </el-table-column>
        <el-table-column
          align="center"
          prop="createTime"
          label="创建时间"
          width="150"
          show-overflow-tooltip
        >
          <template slot-scope="scope">
            {{
              scope.row.createTime
                ? String(scope.row.createTime).slice(0, 10)
                : "-"
            }}
          </template>
        </el-table-column>
        <el-table-column
          align="center"
          prop="status"
          label="课程状态"
          width="120"
          show-overflow-tooltip
        >
          <template slot-scope="scope">
            <el-tag
              v-if="Number(scope.row.status) === 2"
              size="mini"
              type="warning"
              >草稿</el-tag
            >
            <el-switch
              v-else
              v-model="scope.row.status"
              :active-value="0"
              :inactive-value="1"
              @change="IsPublish(scope.row)"
            ></el-switch>
          </template>
        </el-table-column>
        <el-table-column align="center" label="操作" width="420">
          <template slot-scope="scope">
            <el-button
              plain
              round
              size="small"
              type="primary"
              @click="openDetail(scope.row)"
              >详情</el-button
            >
            <el-button
              plain
              round
              size="small"
              type="success"
              @click="openClone(scope.row)"
              >克隆</el-button
            >
            <el-button
              plain
              round
              size="small"
              type="warning"
              v-show="Number(scope.row.status) !== 0"
              @click="toEdit(scope.row)"
              >编辑</el-button
            >
            <el-button
              plain
              round
              size="small"
              type="danger"
              @click="deleteUser(scope.$index, scope.row)"
              v-show="Number(scope.row.status) !== 0"
              >删除</el-button
            >
            <!-- 指定人员暂时隐藏
            <el-button
              plain
              round
              size="small"
              type="success"
              v-if="showAssignMembers(scope.row)"
              @click="openStudentDialog(scope.row)"
              >指定人员</el-button
            >
            -->
          </template>
        </el-table-column>
      </el-table>
      <!-- 分页组件 -->
      <el-pagination
        :key="pagerKey"
        @current-change="handleCurrentChange"
        :current-page.sync="pageParams.pageNum"
        :page-size="pageParams.pageSize || 10"
        layout="total, prev, pager, next"
        :total="totals"
      >
      </el-pagination>
    </div>
    <CourseAddDialog ref="courseAddDialogRef" />
    <StudentDialog ref="studentDialogRef" @success="select" />
    <CourseShelfForm ref="courseShelfFormRef" @success="select" />
    <CourseCloneDialog ref="courseCloneDialogRef" @success="select" />
  </div>
</template>

<script>
import Pagination from "@/components/Pagination";
import CourseAddDialog from "./CourseAddDialog.vue";
import CourseShelfForm from "./CourseShelfForm.vue";
import CourseCloneDialog from "./CourseCloneDialog.vue";
import {
  getCourseList,
  deleteCourse,
  offlineCourse
} from "@/api/course";
import { getDictOptions, DICT_TYPE } from "@/utils/dict.js";
import StudentDialog from "./StudentDialog.vue";
import { saveListQuery, getListQuery } from "@/utils/listQueryCache";
const LIST_CACHE_KEY = "/course";

function isCourseListPath(path) {
  const p = (path || "").split("?")[0];
  return p === "/course" || p === "/course/index";
}

function isCourseChildPath(path) {
  const p = (path || "").split("?")[0];
  return p.startsWith("/course/") && !isCourseListPath(p);
}

export default {
  name: "Course",
  data() {
    return {
      DICT_TYPE,
      values: "",
      totals: 0,
      loading: false,
      payType: null,
      listData: [],
      pagerKey: 0,
      pagerSilent: false,
      pageParams: {
        pageNum: 1,
        pageSize: 10,
        courseName: null,
        courseType: null,
        publisher: null
      }
    };
  },
  components: {
    Pagination,
    CourseAddDialog,
    StudentDialog,
    CourseShelfForm,
    CourseCloneDialog
  },
  computed: {
    courseTypeOptions() {
      const list = getDictOptions(DICT_TYPE.COURSE_TYPE);
      const seen = {};
      return list.filter(item => {
        const key = String(item.dictValue);
        if (seen[key]) return false;
        seen[key] = true;
        return true;
      });
    }
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      vm.initListFromRoute(from);
    });
  },
  beforeRouteLeave(to, from, next) {
    saveListQuery(LIST_CACHE_KEY, { pageParams: { ...this.pageParams } });
    next();
  },
  methods: {
    applyCachedPageParams(cachedParams = {}) {
      const pageNum = Number(cachedParams.pageNum) || 1;
      const pageSize = Number(cachedParams.pageSize) || 10;
      this.pageParams.pageNum = pageNum;
      this.pageParams.pageSize = pageSize;
      this.pageParams.courseName =
        cachedParams.courseName === undefined ||
        cachedParams.courseName === null
          ? null
          : cachedParams.courseName;
      this.pageParams.courseType =
        cachedParams.courseType === undefined ||
        cachedParams.courseType === null ||
        cachedParams.courseType === ""
          ? null
          : cachedParams.courseType;
      this.pageParams.publisher =
        cachedParams.publisher === undefined || cachedParams.publisher === null
          ? null
          : cachedParams.publisher;
    },
    initListFromRoute(from) {
      if (from && isCourseChildPath(from.path)) {
        const cached = getListQuery(LIST_CACHE_KEY);
        if (cached && cached.pageParams) {
          this.applyCachedPageParams(cached.pageParams);
        }
      }
      this.select({ restorePager: true });
    },
    openDetail(row) {
      this.$router.push({
        path: `/course/detail`,
        query: { courseCode: row.courseCode }
      });
    },
    /** 公开课(0)仅需报名时可指定；加密课(1)可指定人员 */
    showAssignMembers(row) {
      const needSignUp = Number(row.isNeedSignUp) === 1;
      const courseType = Number(row.courseType);
      // CourseAdminListVo: 0=公开课程（自主报名+指定人员），1=加密课程（指定人员）
      if (courseType === 1) return true;
      return needSignUp;
    },
    async select(options = {}) {
      const restorePager = !!(options && options.restorePager);
      const pageNum = Number(this.pageParams.pageNum) || 1;
      this.pageParams.pageNum = pageNum;
      this.pagerSilent = true;
      this.loading = true;
      try {
        const result = await getCourseList(this.pageParams);
        this.listData = result.data.rows;
        this.totals = Number(result.data.total) || 0;
        // total 更新后 el-pagination 可能把页码打回 1，这里强制回写并刷新分页
        this.pageParams.pageNum = pageNum;
        if (restorePager) {
          this.pagerKey += 1;
        }
        saveListQuery(LIST_CACHE_KEY, { pageParams: { ...this.pageParams } });
        await this.$nextTick();
        this.pageParams.pageNum = pageNum;
      } catch (e) {
      } finally {
        this.loading = false;
        this.$nextTick(() => {
          this.pagerSilent = false;
        });
      }
    },
    toEdit(val) {
      this.$router.push({
        path: `/course/edit`,
        query: { courseCode: val.courseCode }
      });
    },
    openClone(row) {
      this.$refs.courseCloneDialogRef.open(row);
    },
    async IsPublish(row) {
      const nextStatus = row.status;
      // status: 0上架 1下架；上架时先回滚开关，打开上架表单
      if (nextStatus === 0) {
        row.status = 1;
        if (row.lessonCount == 0) {
          this.$message.error("课时不能为空");
          return;
        }
        this.$refs.courseShelfFormRef.open(row);
        return;
      }
      // 下架：确认后调用下架专用接口
      try {
        await this.$confirm("确定要下架该课程吗？", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        });
      } catch (e) {
        row.status = 0;
        return;
      }
      try {
        await offlineCourse(row.courseCode);
        this.$message.success("下架成功");
        this.select();
      } catch (e) {
        row.status = 0;
      }
    },
    changeCourse(val) {
      this.pageParams.pageNum = val;
      this.select();
    },
    handleCurrentChange(val) {
      if (this.pagerSilent) return;
      this.pageParams.pageNum = val;
      this.select();
    },
    addForms() {
      this.$router.push({
        path: `/course/edit`
      });
    },
    resetSelect() {
      this.pageParams.pageNum = 1;
      this.pageParams.pageSize = 10;
      this.pageParams.courseName = "";
      this.pageParams.courseType = null;
      this.pageParams.publisher = "";
      this.select({ restorePager: true });
    },
    handleEdit(index, row) {
      this.$router.push({ name: "发布课程", params: { code: row } });
    },
    async deleteDetail(val) {
      try {
        await deleteCourse(val);
        this.$message.success("删除成功");
        this.select();
      } catch (e) {}
    },
    openStudentDialog(row) {
      this.$refs.studentDialogRef.open(row);
    },
    deleteUser(index, row) {
      this.$confirm("确定要删除吗?", "信息", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          this.deleteDetail(row.courseCode);
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除"
          });
        });
    }
  }
};
</script>

<style scoped lang="less"></style>



// WEBPACK FOOTER //
// src/views/Course/index.vue